import { render, staticRenderFns } from "./OrServerMonitorModule.vue?vue&type=template&id=260ef6a8&scoped=true&"
import script from "./OrServerMonitorModule.vue?vue&type=script&lang=ts&"
export * from "./OrServerMonitorModule.vue?vue&type=script&lang=ts&"
import style0 from "./OrServerMonitorModule.vue?vue&type=style&index=0&id=260ef6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ef6a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
